module.exports = __webpack_public_path__ + "img/Big-Commerce_logo.415e1d90.jpg";